import { Container, Texture } from 'pixi.js';
import type { VineState } from '@benji/sim-core';
import { VineView } from './VineView';

/**
 * Render-only pool of {@link VineView}s kept in sync with the authoritative
 * `round.vines()` list: spawns a view when a new VineState appears, drops it
 * when the sim removes the vine (broken-faded / culled).
 */
export class VineFieldView extends Container {
  private readonly views = new Map<VineState, VineView>();

  constructor(private readonly textures: Record<string, Texture>) {
    super();
  }

  sync(vines: readonly VineState[], alpha: number) {
    const live = new Set(vines);

    for (const [vine, view] of this.views) {
      if (!live.has(vine)) {
        this.removeChild(view);
        view.destroy({ children: true });
        this.views.delete(vine);
      }
    }

    for (const vine of vines) {
      let view = this.views.get(vine);
      if (!view) {
        view = new VineView(this.textures, vine);
        this.views.set(vine, view);
        this.addChild(view);
      }
      view.sync(alpha);
    }
  }

  clear() {
    for (const view of this.views.values()) {
      this.removeChild(view);
      view.destroy({ children: true });
    }
    this.views.clear();
  }
}
